export default __webpack_public_path__ + "static/media/arrow-right.6b8e1c90.svg";